import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProgressBarService {
  private progressBarVisible = new BehaviorSubject<boolean>(false);

  progressBarVisible$ = this.progressBarVisible.asObservable();

  show(): void {
    this.progressBarVisible.next(true);
  }

  hide(): void {
    this.progressBarVisible.next(false);
  }
}
